import Api from '@/api/rest/MaterialOrderApi';

export default new Api();
